import {Component, OnInit} from '@angular/core';
import {combineLatest} from 'rxjs';
import {UserDetailsModel} from '../../models/users/users.models';
import {Store} from '@ngrx/store';
import {AppState} from '../../../store/models/app-state.model';
import {PerformingViewings} from '../../models/viewings/performing-viewings.models';
import {UserState} from '../../../store/reducers/user';
import * as fromUser from '../../../store/reducers/user';
import * as fromProperty from '../../../store/reducers/property';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-host-details',
  templateUrl: './host-details.component.html',
  styleUrls: ['./host-details.component.scss']
})
export class HostDetailsComponent implements OnInit {
  isLoading = true;
  hostDetails: UserDetailsModel;
  alternativeDetails: UserDetailsModel;
  isSellerDoingViewings = false;


  get hostAvatar(): string {
    return this.hostDetails && Array.isArray(this.hostDetails.uploads) && this.hostDetails.uploads.length > 0 ?
      this.hostDetails.uploads[0].fileName : null;
  }

  get alternativeAvatar(): string {
    return this.alternativeDetails && Array.isArray(this.alternativeDetails.uploads) && this.alternativeDetails.uploads.length > 0 ?
      this.alternativeDetails.uploads[0].fileName : null;
  }

  constructor(private store: Store<AppState>,
              private toastService: ToastrService) {
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.getDetailsFromStore();
  }

  hostTitle(): string {
    const host: string = this.isSellerDoingViewings ? 'Seller' : 'Agent';
    return `Hosted by ${host}`;
  }

  alternativeTitle(): string {
    return this.isSellerDoingViewings ? 'Agent' : 'Seller';
  }

  goToProfileLogic(): string {
    if (this.alternativeDetails) {
      return this.isSellerDoingViewings
        ? `/our-local-agents?lpeName=${this.alternativeDetails.name}#${this.alternativeDetails.id}`
        : `/yopaplus/users/${this.alternativeDetails.id}/detail/history`;
    } else {
      return '#';
    }
  }

  private getDetailsFromStore(): void {
    combineLatest([
      this.store.select(fromProperty.selectPropertyDetailsState),
      this.store.select(fromUser.selectUserState)
    ]).subscribe(([propertyDetails, userStore]) => {
      this.isLoading = true;
      this.isSellerDoingViewings = propertyDetails?.details?.performingViewings === PerformingViewings.SELLER;
      if (!userStore.agentDetails.isLoading && !userStore.sellerDetails.isLoading) {
        this.prepareDetails(userStore);
      }
    });
  }

  private prepareDetails(store: UserState): void {
    this.hostDetails = this.isSellerDoingViewings ? store.sellerDetails.details : store.agentDetails.details;
    this.alternativeDetails = this.isSellerDoingViewings ? store.agentDetails.details : store.sellerDetails.details;
    this.isLoading = false;
  }

  public copyToClipboard(value: string): void {
    if (!value) {
      return;
    }
    navigator.clipboard.writeText(value);
    this.toastService.success(`${value} has been copied to clipboard.`);

  }

}
